import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialModule } from '../../material-module';
import { ColumnsModule } from './columns/columns.module';
import { ItemRendererModule } from './item-renderer/item-renderer.module';
import { ActionValuePipe } from './pipes/action-value.pipe';
import { ColumnDefPipe } from './pipes/column-def.pipe';
import { ColumnValuePipe } from './pipes/column-value.pipe';
import { IsActivePipe } from './pipes/is-active.pipe';
import { IsAllSelectedPipe } from './pipes/is-all-selected.pipe';
import { IsSelectedPipe } from './pipes/is-selected.pipe';
import { NotPipe } from './pipes/not.pipe';
import { RendererPipe } from './pipes/renderer.pipe';
import { RecycleTableComponent } from './table/recycle-table/recycle-table.component';
import { TableComponent } from './table/table.component';

export * from './columns/columns.module';
export { IOptions as ITableOptions } from './interfaces/options.table';

@NgModule({
  declarations: [
    TableComponent,
    RecycleTableComponent,
    IsActivePipe,
    NotPipe,
    RendererPipe,
    IsAllSelectedPipe,
    ColumnDefPipe,
    IsSelectedPipe,
    ColumnValuePipe,
    ActionValuePipe,
  ],
  imports: [CommonModule, MaterialModule, ItemRendererModule],
  exports: [
    TableComponent,
    RecycleTableComponent,
    ItemRendererModule,
    ColumnsModule,
  ],
})
export class TableModule {}
